import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { FaCheck, FaTimes, FaTrash } from "react-icons/fa";
import Edit from "../../assets/images/edit.svg";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CreateNFCAlbum from '../../apis/createNFCAlbum/createNFCAlbum';

const SpecialMessageCell = ({ rowData, onSave, onDelete }) => {
  
  const [image, setImage] = useState(null);
  const [imageName, setImageName] = useState('');
  const fetchImageAsFile = async (imageUrl) => {
    try {
      const response = await fetch(imageUrl);
      if (!response.ok) throw new Error('Failed to fetch image');

      const blob = await response.blob();

      const urlParts = imageUrl.split('/');
      let filename = urlParts[urlParts.length - 1].split('?')[0];

      filename = filename.replace(/\d+_*/g, '');
      filename = filename.replace(/^[^\w]+|[^\w]+$/g, '');
      filename = filename || 'image.jpg';

      const file = new File([blob], filename, { type: blob.type });
      return file;
    } catch (error) {
      console.error('Error fetching image as file:', error);
      return null;
    }
  };
  useEffect(() => {

    if (rowData) {
      if (rowData.albumPic) {
        fetchImageAsFile(rowData.albumPic)
          .then(file => {
            setImage(file);
            setImageName(file.name);
          })
          .catch(error => console.error('Error converting image:', error));
      }
    }


  }, [rowData]);
  const [showPopup, setShowPopup] = useState(false);
  const [newMessage, setNewMessage] = useState(rowData.specialMessage || "");
  const [isLoading, setLoading] = useState(false);
  const handleSave = async (e) => {
    if (newMessage.trim() !== "") {

      setLoading(true);

      const formData = new FormData();
      formData.append('Title', rowData.title);
      formData.append('Description', rowData.description);
      formData.append('SpecialMessage', newMessage);
      formData.append('isPublicLibrary', rowData.isPublicLibrary);
      if (image) formData.append('AlbumCover', image);

      if (rowData.eventUrl) {
        formData.append('EventUrl', rowData.eventUrl);
      }
      else {
        formData.append('EventUrl', 'album');
      }
      if (rowData.id) {
        formData.append('AlbumId', rowData.id);
        formData.append('FolderName', rowData.albumPic)
        if (rowData.image) {
          formData.append('IsPicChanged', true);
          formData.append('AlbumCover', image);
        } else {
          formData.append('IsPicChanged', false);
         
        }
      }
      else{
         formData.append('FolderName', '')
      }
      console.log("FormData entries:");
      for (let [key, value] of formData.entries()) {
        console.log(key, value);
      }

      try {
        const authenticationToken = sessionStorage.getItem('token');
        const response = await CreateNFCAlbum(authenticationToken, formData);
        if (response.result === 1 && response.errorValue === null) {

          if (rowData.title) {
            toast.success('Special Message successfully updated!');
            setTimeout(() => {
              setShowPopup(false);

            }, 1000);
          }

        } else if (response.result === 0 && response.errorValue && response.errorValue.errorCode === 103) {
          console.error('Invalid authentication token:', response.errorValue.errorText);
          sessionStorage.clear();

        } else {
          console.error('API call returned an error:', response);
        }
      } catch (error) {
        console.error('API call error:', error);
      } finally {
        setLoading(false);
      }

    }
  };

  const handleCancel = () => {
    setNewMessage(rowData.specialMessage || "");
    setShowPopup(false);
  };

  const handleDeleteClick = () => {
    if (window.confirm("Are you sure you want to delete this message?")) {
      onDelete(rowData.id);
    }
  };

  const truncateMessage = (msg) => {
    if (!msg) return "";
    return msg.length > 30 ? msg.substring(0, 50) + "..." : msg;
  };

  // modal UI
  const modal = (
    <div className="album-modal-overlay" onClick={handleCancel}>
      <div className="album-modal" onClick={(e) => e.stopPropagation()}>
        <h3>Edit Special Message</h3>
        <textarea
          value={newMessage}
          onChange={(e) => setNewMessage(e.target.value)}
          className="album-input"
          rows={5}
          autoFocus
        />
        <div className="album-actions" style={{ display: "flex", justifyContent: "flex-end", gap: "10px", marginTop: "10px" }}>
          <FaCheck style={{ color: "green", cursor: "pointer" }} onClick={handleSave} />
          <FaTimes style={{ color: "red", cursor: "pointer" }} onClick={handleCancel} />
        </div>
      </div>
    </div>
  );

  return (
    <div className="album-cell" style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
      {rowData.specialMessage ? (
        <>
          <span className="">{truncateMessage(rowData.specialMessage)}</span>
          <div style={{ display: "flex", gap: "8px" }}>
            <img
              src={Edit}
              alt="Edit"
              className="album-edit-icon"
              width={15}
              height={15}
              onClick={() => setShowPopup(true)}
              style={{ cursor: "pointer" }}
            />
            <FaTrash
              size={13}
              style={{ cursor: "pointer", color: "red" }}
              onClick={handleDeleteClick}
              className="album-edit-icon"
            />
          </div>
        </>
      ) : (
        null
      )}

      {showPopup && createPortal(modal, document.body)}
    </div>
  );
   <ToastContainer />
};

export default SpecialMessageCell;
